import Vue from 'vue'
import CustomTable from '../components/table/CustomTable.vue'
import DatePickerModel from '../components/common/DatePickerModel.vue'
import MonthPickerModel from '../components/common/MonthPickerModel.vue'
import SelectMultiple from '../components/common/SelectMultiple.vue'
import SelectPosModel from '../components/common/SelectPosModel.vue'
import SelectWarehouseModel from '../components/common/SelectWarehouseModel.vue'
import InputQrScanModel from '../components/common/InputQrScanModel.vue'
import SelectSuggestBuyer from '../components/common/SelectSuggestBuyer.vue'
import DateTimePicker from '../components/common/DateTimePicker.vue'
import TimePickerDialog from '../components/common/TimePickerDialog.vue'
import DatePickerMultipleDialog from '../components/common/DatePickerMultipleDialog.vue'
import SelectMultipleModel from '../components/common/SelectMultipleModel.vue'
import SelectTaxCodeModel from '../components/common/SelectTaxCodeModel.vue'
import InputMoney from '../components/common/InputMoney.vue'
import InputNumber from '../components/common/InputNumber.vue'
import Otp from '../components/common/Otp.vue'
import SelectBranchModel from '../components/common/SelectBranchModel.vue'
import VueViewer from 'v-viewer'
import VueToastify from "vue-toastify";

Vue.component(CustomTable.name, CustomTable)
Vue.component(InputMoney.name, InputMoney)
Vue.component(InputNumber.name, InputNumber)
Vue.component(DatePickerModel.name, DatePickerModel)
Vue.component(MonthPickerModel.name, MonthPickerModel)
Vue.component(SelectMultiple.name, SelectMultiple)
Vue.component(SelectPosModel.name, SelectPosModel)
Vue.component(SelectWarehouseModel.name, SelectWarehouseModel)
Vue.component(InputQrScanModel.name, InputQrScanModel)
Vue.component(SelectSuggestBuyer.name, SelectSuggestBuyer)
Vue.component(DateTimePicker.name, DateTimePicker)
Vue.component(TimePickerDialog.name, TimePickerDialog)
Vue.component(DatePickerMultipleDialog.name, DatePickerMultipleDialog)
Vue.component(SelectMultipleModel.name, SelectMultipleModel)
Vue.component(SelectTaxCodeModel.name, SelectTaxCodeModel)
Vue.component(SelectBranchModel.name, SelectBranchModel)
Vue.component(Otp.name, Otp)
Vue.use(VueViewer)
Vue.use(VueToastify)
